import { Link } from "react-router-dom";
import { filmInfo } from "@/data/chapters";

const infoRows = [
  { label: "上映年份", value: filmInfo.year },
  { label: "影片时长", value: filmInfo.runtime },
  { label: "导演", value: filmInfo.director },
  { label: "主演", value: filmInfo.stars },
];

export default function SynopsisSection() {
  return (
    <section className="container-page py-14 md:py-20">
      <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-14">
        <div className="relative w-full">
          <div className="relative aspect-[3/4] w-full overflow-hidden rounded-lg border border-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=artistic%20cinematic%20poster%20with%20an%20elegant%20woman%20silhouette%20in%20a%20dark%20red%20cheongsam%20standing%20in%20a%20shadowy%20doorway%2C%20warm%20amber%20light%20and%20deep%20burgundy%20tones%2C%20film%20noir%20atmosphere%2C%20soft%20grain%2C%20no%20text&width=800&height=1100&seq=sj-poster-main&orientation=portrait"
              alt="色戒无删减版 影片主海报"
              title="色戒无删减版 电影完整版海报"
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/10 to-transparent" />
            <span className="absolute left-4 top-4 rounded-full bg-accent-500 px-3 py-1 font-label text-[11px] font-medium tracking-wide text-background-50">
              完整版 · 全 12 章
            </span>
            <Link
              to="/detail/chapter-01"
              className="group absolute inset-x-4 bottom-4 flex items-center justify-between rounded-md border border-foreground-950/20 bg-background-50/70 px-4 py-3 backdrop-blur transition-colors hover:border-accent-500"
            >
              <span className="flex flex-col">
                <span className="font-label text-[11px] tracking-[0.2em] text-accent-400">从第一章开始</span>
                <span className="mt-0.5 font-heading text-sm text-foreground-950">牌桌上的暗流</span>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-background-50 transition-transform group-hover:scale-105">
                <i className="ri-play-fill text-base leading-none" />
              </span>
            </Link>
          </div>
        </div>

        <div>
          <div className="flex items-center gap-2">
            <span className="h-px w-8 bg-accent-500" />
            <span className="font-label text-xs tracking-[0.28em] text-accent-500">影片简介</span>
          </div>
          <h2 className="mt-3 font-heading text-2xl leading-snug text-foreground-950 md:text-[34px]">
            一场以演戏开始的靠近，
            <br className="hidden sm:block" />
            最后谁也没能全身而退
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-foreground-700 md:text-[15px]">
            故事发生在战火未熄的年代，一群年轻人以戏剧为伪装，把真实的人生搬上危险的舞台。她带着任务走进另一个人的生活，也带着一枚戒指走进自己的动摇。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
            本站按剧情时间线把影片拆成 12 个章节，每一章都配有独立封面、剧情摘要与完整解说。你可以从牌桌开场，也可以直接跳到那颗改变一切的钻石。
          </p>

          <dl className="mt-7 grid grid-cols-1 gap-x-8 gap-y-4 border-t border-background-200 pt-6 sm:grid-cols-2">
            {infoRows.map((row) => (
              <div key={row.label} className="flex flex-col gap-1">
                <dt className="font-label text-[11px] tracking-[0.18em] text-foreground-500">{row.label}</dt>
                <dd className="text-sm text-foreground-900">{row.value}</dd>
              </div>
            ))}
          </dl>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/detail/chapter-01"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm text-foreground-950 transition-colors hover:bg-primary-600"
            >
              <i className="ri-play-circle-line text-base leading-none" />
              进入播放页
            </Link>
            <Link
              to="/category"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 font-label text-sm text-foreground-800 transition-colors hover:border-accent-500 hover:text-accent-400"
            >
              剧情章节导航
              <i className="ri-arrow-right-line text-base leading-none" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}